
import "./announcement.css"

const Announcement = () => {
  return <div className="Announcement">Бессплатная доставка при заказе на сумму выше 50000руб!</div>;
};

export default Announcement;